import React from 'react';

type SplitViewIconProps = {
  className?: string;
};

export const SplitViewIcon: React.FC<SplitViewIconProps> = ({ className = 'w-4 h-4' }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <rect x="4" y="4" width="7" height="16" rx="2" strokeWidth={2} />
    <rect x="13" y="4" width="7" height="16" rx="2" strokeWidth={2} />
  </svg>
);

